// /* tslint:disable */
'use strict';
import * as VehiclesModule from 'Modules/VehiclesModule';
import * as LeafletMain from 'leaflet';
const rbush = require('rbush');

window['rbush'] = rbush;

export type CanvasMarkerData = {
    data: ExtendedMarker;
    maxX: number;
    maxY: number;
    minX: number;
    minY: number;
};

export class ExtendedMarker extends LeafletMain.Marker {
    constructor(latestDataframe: VehiclesModule.Types.CarDataframeDto, latlng: LeafletMain.LatLngExpression, options?: LeafletMain.MarkerOptions) {
        super(latlng, options);
        this.latestDataframe = latestDataframe;
    }
    public latestDataframe: VehiclesModule.Types.CarDataframeDto;
}

export function layerFactory(L) {
    class CanvasIconLayer extends L.Layer {
        constructor(options) {
            super(options);
        }
        public initialize(options) {
            L.setOptions(this, options);
            this._onClickListeners = [];
            this._onHoverListeners = [];
        }

        public setOptions(options) {
            L.setOptions(this, options);
            return this.redraw();
        }

        public redraw() {
            this._redraw(true);
        }

        public addMarkers(markers) {
            const self = this;
            const tmpMark = [];
            const tmpLatLng = [];

            markers.forEach(function(marker) {
                if (!(marker.options.pane == 'markerPane' && marker.options.icon)) {
                    console.error("Layer isn't a marker");
                    return;
                }

                const latlng = marker.getLatLng();
                const isDisplaying = self._map.getBounds().contains(latlng);
                const s = self._addMarker(marker, latlng, isDisplaying);

                //Only add to Point Lookup if we are on map
                if (isDisplaying === true) {
                    tmpMark.push(s[0]);
                }

                tmpLatLng.push(s[1]);
            });

            self._markers.load(tmpMark);
            self._latlngMarkers.load(tmpLatLng);
        }

        public addMarker(marker) {
            const self = this;
            const latlng = marker.getLatLng();
            const isDisplaying = self._map.getBounds().contains(latlng);
            const dat = self._addMarker(marker, latlng, isDisplaying);

            if (isDisplaying === true) {
                self._markers.insert(dat[0]);
            }

            self._latlngMarkers.insert(dat[1]);
        }

        public addLayer(layer) {
            if (layer.options.pane == 'markerPane' && layer.options.icon) {
                this.addMarker(layer);
            } else {
                console.error("Layer isn't a marker");
            }
        }

        public addLayers(layers) {
            this.addMarkers(layers);
        }

        public removeLayer(layer) {
            this.removeMarker(layer, true);
        }

        public removeMarker(marker, redraw) {
            const self = this;

            if (marker['minX']) {
                marker = marker.data;
            }

            const latlng = marker.getLatLng();
            const isDisplaying = self._map.getBounds().contains(latlng);

            const markerData = {
                minX: latlng.lng,
                minY: latlng.lat,
                maxX: latlng.lng,
                maxY: latlng.lat,
                data: marker
            };

            self._latlngMarkers.remove(markerData, function(a, b) {
                return a.data._leaflet_id === b.data._leaflet_id;
            });

            self._latlngMarkers.total--;
            self._latlngMarkers.dirty++;

            if (isDisplaying === true && redraw === true) {
                self._redraw(true);
            }
        }

        public onAdd(map) {
            this._map = map;

            if (!this._canvas) {
                this._initCanvas();
            }

            if (this.options.pane) {
                this.getPane().appendChild(this._canvas);
            } else {
                map._panes.overlayPane.appendChild(this._canvas);
            }

            map.on('moveend', this._reset, this);
            map.on('resize', this._reset, this);

            map.on('click', this._executeListeners, this);
            map.on('mousemove', this._executeListeners, this);
            if (map._zoomAnimated) {
                map.on('zoomanim', this._animateZoom, this);
            }
        }

        public onRemove(map) {
            if (this.options.pane) {
                this.getPane().removeChild(this._canvas);
            } else {
                map.getPanes().overlayPane.removeChild(this._canvas);
            }

            map.off('click', this._executeListeners, this);
            map.off('mousemove', this._executeListeners, this);

            map.off('moveend', this._reset, this);
            map.off('resize', this._reset, this);
            if (map._zoomAnimated) {
                map.on('zoomanim', this._animateZoom, this);
            }
        }

        public addTo(map) {
            map.addLayer(this);
            return this;
        }
        public _animateZoom(event) {
            const scale = this._map.getZoomScale(event.zoom);
            const offset = this._map._latLngBoundsToNewLayerBounds(this._map.getBounds(), event.zoom, event.center).min;

            L.DomUtil.setTransform(this._canvas, offset, scale);
        }
        public clearLayers() {
            this._latlngMarkers = null;
            this._markers = null;
            this._redraw(true);
        }

        public _addMarker(marker, latlng, isDisplaying) {
            const self = this;
            marker._map = self._map;

            if (!self._markers) {
                self._markers = new rbush();
            }

            if (!self._latlngMarkers) {
                self._latlngMarkers = new rbush();
                self._latlngMarkers.dirty = 0;
                self._latlngMarkers.total = 0;
            }

            L.Util.stamp(marker);

            const pointPos = self._map.latLngToContainerPoint(latlng);
            const iconSize = marker.options.icon.options.iconSize;

            const adj_x = iconSize[0] / 2;
            const adj_y = iconSize[1] / 2;
            const ret = [
                {
                    minX: pointPos.x - adj_x,
                    minY: pointPos.y - adj_y,
                    maxX: pointPos.x + adj_x,
                    maxY: pointPos.y + adj_y,
                    data: marker
                },
                {
                    minX: latlng.lng,
                    minY: latlng.lat,
                    maxX: latlng.lng,
                    maxY: latlng.lat,
                    data: marker
                }
            ];

            self._latlngMarkers.dirty++;
            self._latlngMarkers.total++;

            if (isDisplaying === true) {
                self._drawMarker(marker, pointPos);
            }

            return ret;
        }

        public _drawMarker(marker, pointPos) {
            const self = this;
            if (!this._imageLookup) {
                this._imageLookup = {};
            }
            if (!pointPos) {
                pointPos = self._map.latLngToContainerPoint(marker.getLatLng());
            }
            const iconUrl = marker.options.icon.options.iconUrl;

            if (marker.canvas_img) {
                self._drawImage(marker, pointPos);
            } else {
                if (self._imageLookup[iconUrl]) {
                    marker.canvas_img = self._imageLookup[iconUrl][0];

                    if (self._imageLookup[iconUrl][1] === false) {
                        self._imageLookup[iconUrl][2].push([marker, pointPos]);
                    } else {
                        self._drawImage(marker, pointPos);
                    }
                } else {
                    const i = new Image();
                    i.src = iconUrl;
                    marker.canvas_img = i;

                    //Image,isLoaded,marker\pointPos ref
                    self._imageLookup[iconUrl] = [i, false, [[marker, pointPos]]];

                    i.onload = function() {
                        self._imageLookup[iconUrl][1] = true;
                        self._imageLookup[iconUrl][2].forEach(function(e) {
                            self._drawImage(e[0], e[1]);
                        });
                    };
                }
            }
        }

        public _drawImage(marker, pointPos) {
            const options = marker.options.icon.options;
            const heading = parseInt(options.className.split('rotate_')[1]);
            this._context.save();
            this._context.translate(pointPos.x, pointPos.y);
            this._context.rotate(heading);
            this._context.translate(-pointPos.x, -pointPos.y);
            this._context.drawImage(marker.canvas_img, pointPos.x - options.iconAnchor[0], pointPos.y - options.iconAnchor[1], options.iconSize[0], options.iconSize[1]);
            this._context.restore();
        }

        public _reset() {
            const topLeft = this._map.containerPointToLayerPoint([0, 0]);
            L.DomUtil.setPosition(this._canvas, topLeft);

            const size = this._map.getSize();

            this._canvas.width = size.x;
            this._canvas.height = size.y;

            this._redraw();
        }

        public _redraw(clear?) {
            const self = this;

            if (clear) {
                this._context.clearRect(0, 0, this._canvas.width, this._canvas.height);
            }
            if (!this._map || !this._latlngMarkers) {
                return;
            }

            let tmp = [];

            //If we are 10% individual inserts\removals, reconstruct lookup for efficiency
            if (self._latlngMarkers.dirty / self._latlngMarkers.total >= 0.1) {
                self._latlngMarkers.all().forEach(function(e) {
                    tmp.push(e);
                });

                self._latlngMarkers.clear();
                self._latlngMarkers.load(tmp);
                self._latlngMarkers.dirty = 0;
                tmp = [];
            }

            const mapBounds = self._map.getBounds();

            const mapBoxCoords = {
                minX: mapBounds.getWest(),
                minY: mapBounds.getSouth(),
                maxX: mapBounds.getEast(),
                maxY: mapBounds.getNorth()
            };

            self._latlngMarkers.search(mapBoxCoords).forEach(function(e) {
                const pointPos = self._map.latLngToContainerPoint(e.data.getLatLng());

                const iconSize = e.data.options.icon.options.iconSize;
                const adj_x = iconSize[0] / 2;
                const adj_y = iconSize[1] / 2;

                const newCoords = {
                    minX: pointPos.x - adj_x,
                    minY: pointPos.y - adj_y,
                    maxX: pointPos.x + adj_x,
                    maxY: pointPos.y + adj_y,
                    data: e.data
                };

                tmp.push(newCoords);

                self._drawMarker(e.data, pointPos);
            });

            this._markers.clear();
            this._markers.load(tmp);
        }

        public _initCanvas() {
            this._canvas = L.DomUtil.create('canvas', 'leaflet-canvas-icon-layer leaflet-layer');
            // const originProp = L.DomUtil.testProp(['transformOrigin', 'WebkitTransformOrigin', 'msTransformOrigin']);
            // this._canvas.style[originProp] = '50% 50%';

            const size = this._map.getSize();
            this._canvas.width = size.x;
            this._canvas.height = size.y;

            this._context = this._canvas.getContext('2d');

            const animated = this._map.options.zoomAnimation && L.Browser.any3d;
            L.DomUtil.addClass(this._canvas, 'leaflet-zoom-' + (animated ? 'animated' : 'hide'));
        }

        public addOnClickListener(listener) {
            this._onClickListeners.push(listener);
        }

        public addOnHoverListener(listener) {
            this._onHoverListeners.push(listener);
        }

        public _executeListeners(event) {
            if (!this._markers) {
                return;
            }

            const me = this;
            const x = event.containerPoint.x;
            const y = event.containerPoint.y;

            if (me._openToolTip) {
                me._openToolTip.closeTooltip();
                delete me._openToolTip;
            }

            const ret = this._markers.search({ minX: x, minY: y, maxX: x, maxY: y });

            if (ret && ret.length > 0) {
                me._map._container.style.cursor = 'pointer';

                if (event.type === 'click') {
                    const hasPopup = ret[0].data.getPopup();
                    if (hasPopup) {
                        ret[0].data.openPopup();
                    }

                    me._onClickListeners.forEach(function(listener) {
                        listener(event, ret);
                    });
                }

                if (event.type === 'mousemove') {
                    const hasTooltip = ret[0].data.getTooltip();
                    if (hasTooltip) {
                        me._openToolTip = ret[0].data;
                        ret[0].data.openTooltip();
                    }

                    me._onHoverListeners.forEach(function(listener) {
                        listener(event, ret);
                    });
                }
            } else {
                me._map._container.style.cursor = '';
            }
        }
    }
    L.marker = function(latestDataframe: VehiclesModule.Types.CarDataframeDto, latlng: L.LatLngExpression, options?: L.MarkerOptions): ExtendedMarker {
        return new ExtendedMarker(latestDataframe, latlng, options);
    };
    L.canvasIconLayer = function(options): CanvasIconLayer {
        return new CanvasIconLayer(options);
    };
    return L;
}



// WEBPACK FOOTER //
// ./src/components/Map/MapHelpers/CanvasMarkersLayer/leaflet.canvas-markers.ts